import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

export const DEFAULT_PUBLISH_PAGE_SIZE = 50;

export const PUBLISH_STAGES = ['sales', 'mis', 'accounts', 'all'] as const;
export type PublishStage = (typeof PUBLISH_STAGES)[number];

export const PUBLISH_PANEL_PATH = {
  sales: '/publish/sales',
  mis: '/publish/mis',
  accounts: '/publish/accounts',
} as const;

export const PUBLISH_PANEL_PATHS = [
  PUBLISH_PANEL_PATH.sales,
  PUBLISH_PANEL_PATH.mis,
  PUBLISH_PANEL_PATH.accounts,
] as const;

export const BATCH_STAGE_LABEL: Record<string, string> = {
  awaiting_mis: 'Awaiting MIS',
  sent_back: 'Sent back',
  confirmed: 'Confirmed',
  disbursed: 'Disbursed',
};

export const BATCH_STAGE_TONE: Partial<Record<string, StatusColorTone>> = {
  awaiting_mis: APPROVAL_STATUS_TONE.pending,
  sent_back: APPROVAL_STATUS_TONE.rejected,
  confirmed: APPROVAL_STATUS_TONE.recommended,
  disbursed: APPROVAL_STATUS_TONE.approved,
};
